// useRefreshToken.js
import { useNavigate } from "react-router-dom";
import { BaseURL } from "./appConstant";
import { delete_user_data_from_client_side } from "./common";

const useRefreshToken = () => {
    const navigate = useNavigate();

    const refreshToken = async () => {
        const refresh_token = localStorage.getItem("refresh_token");
        try {
            const refreshResponse = await fetch(`${BaseURL}/refresh_token`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${refresh_token}` // Include the refresh token in the Authorization header
                },
                body: JSON.stringify({ refresh_token: refresh_token })
            });
            if (refreshResponse.ok) {
                const data = await refreshResponse.json();
                const newAccessToken = data.access_token;

                document.cookie = `access_token_cookie=${data.access_token}; path=/; SameSite=None; Secure`;
                localStorage.setItem("access_token", data.access_token);
            } else {
                throw new Error("Failed to refresh token");
            }
        } catch (error) {
            console.error("Failed to refresh token", error);
            delete_user_data_from_client_side()
            navigate("/user_login");
        }
    };

    return refreshToken;
};

export default useRefreshToken;
